<template #content>
    <Dialog
        v-if="mode === 'standalone'"
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-6"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Conta</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">

            <Tabs v-model:value="tabIndex">
                <TabList>
                    <Tab :value="0">Informações</Tab>
                    <Tab :value="1" :disabled="!form.id">Arquivos</Tab>
                    <Tab :value="2">Beneficiário</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <ScrollPanel style="height: 62vh">
                            <div class="w-full">

                                <div class="field mt-4">
                                    <label class="block font-medium mb-3">Tipo de Lançamento <span class="text-red-500">*</span></label>
                                    <div class="flex gap-4 flex-wrap">
                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_mensalidade" name="tipo_conta" value="mensalidade" />
                                            <label for="tipo_mensalidade" class="ml-2 cursor-pointer">Mensalidade</label>
                                        </div>

                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_prorata" name="tipo_conta" value="prorata" />
                                            <label for="tipo_prorata" class="ml-2 cursor-pointer">Prorata</label>
                                        </div>

                                        <div class="flex align-items-center">
                                            <RadioButton v-model="form.tipo_conta" inputId="tipo_avulso" name="tipo_conta" value="avulso" />
                                            <label for="tipo_avulso" class="ml-2 cursor-pointer">Avulso/Outros</label>
                                        </div>
                                    </div>
                                    <div class="text-xs text-red-500 mt-1">{{ errors['tipo_conta'] }}</div>
                                </div>

                                <div class="field mt-5">
                                    <FloatLabel>
                                        <Select
                                            id="tipo_cobranca"
                                            v-model="form.tipo_cobranca"
                                            :options="tiposCobrancaOpcoes"
                                            optionLabel="label"
                                            optionValue="value"
                                            class="w-full"
                                            appendTo="body"
                                        />
                                        <label for="tipo_cobranca">Tipo de Cobrança <span class="text-red-500">*</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500 mt-1">{{ errors['tipo_cobranca'] }}</div>
                                </div>

                            <div class="field mt-4">
                                    <InputGroup>
                                        <FloatLabel>
                                            <InputText id="contrato_id" v-model="form.id_primario" class="w-full" readonly />
                                            <label for="contrato_id">Contrato<span v-if="contratoObrigatorio" class="text-red-500"> *</span></label>
                                        </FloatLabel>
                                        <Button icon="pi pi-search" severity="info" @click="visibleContratoListSelect = true"></Button>
                                        <Button icon="pi pi-times" severity="danger" @click="clearContrato"></Button>
                                    </InputGroup>
                                    <div class="text-xs text-red-500">{{ errors['contrato_id'] }}</div>
                                    <div v-if="clienteNome" class="text-xs text-gray-500 mt-1">
                                        <i class="pi pi-building mr-1"></i>Cliente: {{ clienteNome }}
                                    </div>
                            </div>

                            <Message
                                v-if="pagamentoRequisitos.msg && !pagamentoRequisitos.ok"
                                severity="warn"
                                :closable="false"
                                class="mt-3 w-full"
                            >
                                {{ pagamentoRequisitos.msg }}
                                <a
                                    v-if="form.contrato_id"
                                    href="#"
                                    class="ml-2 underline font-medium"
                                    @click.prevent="irParaConfigurarContrato"
                                >
                                    {{ linkConfigLabel }}
                                </a>
                            </Message>

                            <div v-if="exigeJustificativa" class="field mt-4">
                                <FloatLabel>
                                    <Textarea id="justificativa_preco" v-model="form.justificativa_preco" class="w-full" rows="5" cols="30" />
                                    <label for="justificativa_preco">{{ regrasIntegridade.justificativa_label || 'Justificativa de preços' }}<span class="text-red-500"> *</span></label>
                                </FloatLabel>
                                <small class="text-color-secondary">
                                    Obrigatória quando não há contrato vinculado (mín. {{ regrasIntegridade.justificativa_min || 10 }} caracteres).
                                </small>
                                <div class="text-xs text-red-500">{{ errors['justificativa_preco'] }}</div>
                            </div>

                            <div class="list-none p-0 m-0 flex flex-row gap-4 mt-4">


                                <div class="flex-1">

                                    <FloatLabel>
                                        <InputNumber id="valor" v-model="form.valor" :minFractionDigits="2" :maxFractionDigits="5" class="w-full" prefix="R$ " fluid />
                                        <label for="valor">Valor<span class="text-red-500"> *</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['valor'] }}</div>
                                </div>

                                <div class="flex-1" >


                                        <FloatLabel>
                                                    <DatePicker id="data_vencimento" v-model="form.data_vencimento"
                                                        showIcon class="w-full" dateFormat="dd/mm/yy" />
                                                    <label for="data_vencimento">Vencimento<span class="text-red-500"> *</span></label>
                                        </FloatLabel>


                                    <div class="text-xs text-red-500">{{ errors['data_vencimento'] }}</div>
                                </div>

                                <div class="flex-1" >


                                    <FloatLabel>
                                                <DatePicker id="data_pagamento" v-model="form.data_pagamento"
                                                    showIcon class="w-full" dateFormat="dd/mm/yy" />
                                                <label for="data_pagamento">Data Pagamento</label>
                                    </FloatLabel>


                                    <div class="text-xs text-red-500">{{ errors['data_pagamento'] }}</div>
                                </div>


                            </div>

                                <div class="field mt-4">

                                        <FloatLabel>
                                            <Textarea id="observacao" v-model="form.observacao" class="w-full" rows="7" cols="30" />
                                            <label for="observacao">Observação</label>
                                        </FloatLabel>

                                    <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
                                    </div>




                            </div>
                        </ScrollPanel>

                    </TabPanel>

                    <TabPanel :value="1">
                        <ScrollPanel style="height: 62vh">
                            <FormTabArquivos
                                v-if="form.id"
                                :data="form"
                                @save="onUploadFile"
                                @remove="onRemoveFile"
                                @ia-dados-extraidos="onIaDadosExtraidos"
                            />
                        </ScrollPanel>

                    </TabPanel>

                    <TabPanel :value="2">
                        <ScrollPanel style="height: 62vh">
                            <FormTabBeneficiario v-if="tabIndex === 2" :data="form" />
                        </ScrollPanel>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <div class="flex justify-content-end flex-wrap">


                <div class="flex justify-content-end gap-1">
                    <Button
                        :disabled="tabIndex === 1 || !podeSalvarPagamento"
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        <ContratoListSelect :visible="visibleContratoListSelect" :clienteId="clienteId" @close="visibleContratoListSelect=false" @select="selectContrato" />
        <LogForm :visible="visibleLogForm" table="contas" :tableId="form.id" @close="this.visibleLogForm=false" />
        <JustificativaAlteracaoDialog
            v-model:texto="justificativa.texto"
            :visible="justificativa.visivel"
            :erro="justificativa.erro"
            @confirmar="onConfirmarJustificativa"
            @cancelar="justificativa.visivel = false" />

    </Dialog>

    <div v-else class="embedded-conta">
        <form @submit.prevent="onSubmit(form)">

            <Tabs v-model:value="tabIndex">
                <TabList>
                    <Tab :value="0" :disabled="informacoesDisabled">Informações</Tab>
                    <Tab :value="1" :disabled="arquivosDisabled">Arquivos</Tab>
                    <Tab :value="2" :disabled="beneficiarioDisabled">Beneficiário</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <div class="w-full">

                            <div class="field mt-4">
                                <label class="block font-medium mb-3">Tipo de Lançamento <span class="text-red-500">*</span></label>
                                <div class="flex gap-4 flex-wrap">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="form.tipo_conta" inputId="emb_tipo_mensalidade" name="emb_tipo_conta" value="mensalidade" :disabled="informacoesReadOnly" />
                                        <label for="emb_tipo_mensalidade" class="ml-2 cursor-pointer">Mensalidade</label>
                                    </div>

                                    <div class="flex align-items-center">
                                        <RadioButton v-model="form.tipo_conta" inputId="emb_tipo_prorata" name="emb_tipo_conta" value="prorata" :disabled="informacoesReadOnly" />
                                        <label for="emb_tipo_prorata" class="ml-2 cursor-pointer">Prorata</label>
                                    </div>

                                    <div class="flex align-items-center">
                                        <RadioButton v-model="form.tipo_conta" inputId="emb_tipo_avulso" name="emb_tipo_conta" value="avulso" :disabled="informacoesReadOnly" />
                                        <label for="emb_tipo_avulso" class="ml-2 cursor-pointer">Avulso/Outros</label>
                                    </div>
                                </div>
                                <div class="text-xs text-red-500 mt-1">{{ errors['tipo_conta'] }}</div>
                            </div>

                            <div class="field mt-5">
                                <FloatLabel>
                                    <Select
                                        id="emb_tipo_cobranca"
                                        v-model="form.tipo_cobranca"
                                        :options="tiposCobrancaOpcoes"
                                        optionLabel="label"
                                        optionValue="value"
                                        class="w-full"
                                        appendTo="body"
                                        :disabled="informacoesReadOnly"
                                    />
                                    <label for="emb_tipo_cobranca">Tipo de Cobrança <span class="text-red-500">*</span></label>
                                </FloatLabel>
                                <div class="text-xs text-red-500 mt-1">{{ errors['tipo_cobranca'] }}</div>
                            </div>

                            <!-- Campo Contrato escondido no modo embedded quando já vem com contrato preenchido
                                 (cenário típico: Frente B do cancelamento — o contrato é o do próprio cancelamento). -->
                            <div v-if="!form.contrato_id" class="field mt-4">
                                <InputGroup>
                                    <FloatLabel>
                                        <InputText id="emb_contrato_id" v-model="form.id_primario" class="w-full" readonly />
                                        <label for="emb_contrato_id">Contrato<span v-if="contratoObrigatorio" class="text-red-500"> *</span></label>
                                    </FloatLabel>
                                    <Button icon="pi pi-search" severity="info" @click="visibleContratoListSelect = true" :disabled="informacoesReadOnly"></Button>
                                    <Button icon="pi pi-times" severity="danger" @click="clearContrato" :disabled="informacoesReadOnly"></Button>
                                </InputGroup>
                                <div class="text-xs text-red-500">{{ errors['contrato_id'] }}</div>
                                <div v-if="clienteNome" class="text-xs text-gray-500 mt-1">
                                    <i class="pi pi-building mr-1"></i>Cliente: {{ clienteNome }}
                                </div>
                            </div>

                            <Message
                                v-if="pagamentoRequisitos.msg && !pagamentoRequisitos.ok"
                                severity="warn"
                                :closable="false"
                                class="mt-3 w-full"
                            >
                                {{ pagamentoRequisitos.msg }}
                                <a
                                    v-if="form.contrato_id && !informacoesReadOnly"
                                    href="#"
                                    class="ml-2 underline font-medium"
                                    @click.prevent="irParaConfigurarContrato"
                                >
                                    {{ linkConfigLabel }}
                                </a>
                            </Message>

                            <div v-if="exigeJustificativa" class="field mt-4">
                                <FloatLabel>
                                    <Textarea id="emb_justificativa_preco" v-model="form.justificativa_preco" class="w-full" rows="5" cols="30" :disabled="informacoesReadOnly" />
                                    <label for="emb_justificativa_preco">{{ regrasIntegridade.justificativa_label || 'Justificativa de preços' }}<span class="text-red-500"> *</span></label>
                                </FloatLabel>
                                <small class="text-color-secondary">
                                    Obrigatória quando não há contrato vinculado (mín. {{ regrasIntegridade.justificativa_min || 10 }} caracteres).
                                </small>
                                <div class="text-xs text-red-500">{{ errors['justificativa_preco'] }}</div>
                            </div>

                            <div class="list-none p-0 m-0 flex flex-row gap-4 mt-4">
                                <div class="flex-1">
                                    <FloatLabel>
                                        <InputNumber id="emb_valor" v-model="form.valor" :minFractionDigits="2" :maxFractionDigits="5" class="w-full" prefix="R$ " fluid :disabled="informacoesReadOnly" />
                                        <label for="emb_valor">Valor<span class="text-red-500"> *</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['valor'] }}</div>
                                </div>

                                <div class="flex-1">
                                    <FloatLabel>
                                        <DatePicker id="emb_data_vencimento" v-model="form.data_vencimento"
                                            showIcon class="w-full" dateFormat="dd/mm/yy" :disabled="informacoesReadOnly" />
                                        <label for="emb_data_vencimento">Vencimento<span class="text-red-500"> *</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['data_vencimento'] }}</div>
                                </div>

                                <div class="flex-1">
                                    <FloatLabel>
                                        <DatePicker id="emb_data_pagamento" v-model="form.data_pagamento"
                                            showIcon class="w-full" dateFormat="dd/mm/yy" :disabled="informacoesReadOnly" />
                                        <label for="emb_data_pagamento">Data Pagamento</label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['data_pagamento'] }}</div>
                                </div>
                            </div>

                            <div class="field mt-4">
                                <FloatLabel>
                                    <Textarea id="emb_observacao" v-model="form.observacao" class="w-full" rows="7" cols="30" :disabled="informacoesReadOnly" />
                                    <label for="emb_observacao">Observação</label>
                                </FloatLabel>
                                <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel :value="1">
                        <FormTabArquivos
                            v-if="form.id"
                            :data="form"
                            :read-only="arquivosReadOnly"
                            @save="onUploadFile"
                            @remove="onRemoveFile"
                            @ia-dados-extraidos="onIaDadosExtraidos"
                        />
                    </TabPanel>

                    <TabPanel :value="2">
                        <FormTabBeneficiario v-if="tabIndex === 2" :data="form" :read-only="beneficiarioReadOnly" />
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <div v-if="!hideSaveButton" class="flex justify-content-end mt-3">
                <Button
                    :disabled="tabIndex === 1 || !podeSalvarPagamento || informacoesReadOnly"
                    type="submit"
                    label="Salvar"
                    severity="success"
                    icon="pi pi-save"
                    size="small"
                    class="flex align-items-center justify-content-center"
                    :loading="isLoading" />
            </div>
        </form>
        <ContratoListSelect :visible="visibleContratoListSelect" :clienteId="clienteId" @close="visibleContratoListSelect=false" @select="selectContrato" />
        <LogForm :visible="visibleLogForm" table="contas" :tableId="form.id" @close="this.visibleLogForm=false" />
        <JustificativaAlteracaoDialog
            v-model:texto="justificativa.texto"
            :visible="justificativa.visivel"
            :erro="justificativa.erro"
            @confirmar="onConfirmarJustificativa"
            @cancelar="justificativa.visivel = false" />
    </div>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import DatePicker from 'primevue/datepicker';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';
import ScrollPanel from 'primevue/scrollpanel';
import Message from 'primevue/message';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import ContratoListSelect from '@/page/contrato/ListaSelect.vue';
import FormTabArquivos from '@/page/conta/FormTabArquivos.vue';
import FormTabBeneficiario from '@/page/conta/FormTabBeneficiario.vue';

import Conta from '@/service/conta.js';
import Integridade from '@/service/integridade.js';
import Provedor from '@/service/provedor.js';

import LogForm from '@/components/LogForm.vue';
import JustificativaAlteracaoDialog from '@/page/conta/JustificativaAlteracaoDialog.vue';
import { retratoEditavel, formularioMudou, erroDeJustificativa, CAMPO_JUSTIFICATIVA } from '@/page/conta/contaAlteracao.js';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        RadioButton,
        InputNumber,
        InputGroup,
        InputGroupAddon,
        DatePicker,
        Textarea,
        FileUpload,
        ScrollPanel,
        Message,

        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,

        LogForm,
        JustificativaAlteracaoDialog,
        ContratoListSelect,
        FormTabArquivos,
        FormTabBeneficiario,
    },
    props: {
        visible: false,
        data: {},
        /** Ao abrir o modal (ex.: após Upload IA), define a aba inicial (0 = Informações, 1 = Arquivos). */
        initialTabIndex: {
            type: Number,
            default: 0,
        },
        /**
         * Modo de uso do formulário:
         * - 'standalone' (padrão): comportamento original — o form gerencia tudo, watchers ativos sempre.
         * - 'embedded': usado quando um componente pai já injetou contrato/cliente via prop `data`.
         *   Nesse modo, os watchers de `form.contrato_id` e `form.justificativa_preco` não disparam
         *   `loadPagamentoRequisitos` durante a inicialização — apenas após interação do usuário.
         *   Isso evita o loop "pai injeta data → watcher dispara → reset → pai re-injeta".
         */
        mode: {
            type: String,
            default: 'standalone',
            validator: (v) => ['standalone', 'embedded'].includes(v),
        },
        /**
         * Lista de abas a desabilitar (clique bloqueado). Valores: 'informacoes', 'arquivos', 'beneficiario'.
         * Só tem efeito no modo embedded.
         */
        disabledTabs: {
            type: Array,
            default: () => [],
        },
        /**
         * Lista de abas em modo read-only (visíveis, mas com campos desabilitados).
         * Valores aceitos: 'informacoes', 'arquivos', 'beneficiario'. Só tem efeito no modo embedded.
         */
        readOnlyTabs: {
            type: Array,
            default: () => [],
        },
        /**
         * Quando true, oculta o botão Salvar (modo só leitura ou quando o pai controla submit).
         */
        hideSaveButton: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['save', 'close', 'configurar-contrato'],
    data() {
        return {
            contrato: {},
            form: {},
            errors: {},
            isLoading: false,
            visibleContratoListSelect: false,
            clienteId: null,
            clienteNome: null,

            visibleLogForm: false,

            tabIndex: 0,
            regrasIntegridade: {},
            pagamentoRequisitos: { ok: true, msg: null, erros: {} },
            isLoadingPagamentoRequisitos: false,
            tiposCobrancaOpcoes: [],
            /** Flag anti-loop: enquanto true, watchers de form.* não disparam side-effects automáticos.
             *  Sobe durante onShow() para evitar cascata de requisições quando o pai injeta `data`. */
            isInitializing: false,
            /** Anti-spam: evita emitir 'configurar-contrato' múltiplas vezes para o mesmo estado de pendência. */
            pendenciaJaEmitida: false,
            /** Campos editáveis como vieram do servidor — base para saber se o usuário mudou algo. */
            formOriginal: null,
            /** Diálogo de justificativa da alteração (exigida pelo servidor em toda edição manual). */
            justificativa: { visivel: false, texto: '', erro: '' },
        }
    },
    mounted() {
        // Em modo embedded não há Dialog → @show nunca dispara. Inicializa manualmente.
        if (this.mode === 'embedded') {
            this.onShow();
        }
    },
    computed: {
        exigeJustificativa() {
            return !this.form.contrato_id;
        },
        contratoObrigatorio() {
            if (!this.regrasIntegridade.justificativa_obrigatoria_sem_referencia) {
                return true;
            }
            return !this.form.justificativa_preco || String(this.form.justificativa_preco).trim().length === 0;
        },
        podeSalvarPagamento() {
            return this.pagamentoRequisitos.ok !== false;
        },
        precisaAssinatura() {
            return !!this.pagamentoRequisitos?.erros?.assinatura;
        },
        linkConfigLabel() {
            return this.precisaAssinatura
                ? 'Anexar documento de assinatura →'
                : 'Configurar financeiro do contrato →';
        },
        informacoesDisabled() {
            return this.disabledTabs.includes('informacoes');
        },
        arquivosDisabled() {
            // Comportamento original: aba Arquivos só habilita após criar a conta.
            // Modo embedded + disabledTabs adiciona um bloqueio extra.
            return this.disabledTabs.includes('arquivos') || !this.form.id;
        },
        informacoesReadOnly() {
            return this.readOnlyTabs.includes('informacoes');
        },
        arquivosReadOnly() {
            return this.readOnlyTabs.includes('arquivos');
        },
        beneficiarioDisabled() {
            return this.disabledTabs.includes('beneficiario');
        },
        beneficiarioReadOnly() {
            return this.readOnlyTabs.includes('beneficiario');
        },
    },
    watch: {
        'form.contrato_id'() {
            if (this.isInitializing) return;
            this.loadPagamentoRequisitos();
        },
        'form.justificativa_preco'() {
            if (this.isInitializing) return;
            if (!this.form.contrato_id) {
                this.loadPagamentoRequisitos();
            }
        },
        'form.tipo_conta'(novoTipo) {
            if (novoTipo) {
                delete this.errors['tipo_conta'];
            }
            // Abrir uma conta também muda tipo_conta (vem do parse). Sem isto o
            // valor era trocado pela cotação do último contrato escolhido.
            if (this.isInitializing) return;
            this.atualizarValorPorTipo(novoTipo);
            // Sugere tipo_cobranca correspondente se ainda não foi preenchido
            if (!this.form.tipo_cobranca) {
                if (novoTipo === 'mensalidade') this.form.tipo_cobranca = 'mensalidade';
                else if (novoTipo === 'prorata') this.form.tipo_cobranca = 'prorata';
            }
        },
        'form.tipo_cobranca'(novoTipo) {
            if (novoTipo) delete this.errors['tipo_cobranca'];
        }
    },
    methods: {
        irParaConfigurarContrato() {
            if (!this.form.contrato_id) return;

            // Em modo embedded, em vez de navegar emitimos para o pai abrir o popup interno.
            if (this.mode === 'embedded') {
                this.$emit('configurar-contrato', {
                    tipo: this.precisaAssinatura ? 'assinatura' : 'financeiro',
                    contrato_id: this.form.contrato_id,
                });
                return;
            }

            this.$emit('update:visible', false);

            if (this.precisaAssinatura) {
                this.$router.push({
                    name: 'contrato.lista',
                    query: {
                        contrato_id: this.form.contrato_id,
                        open_form: 1,
                        tab: 'assinatura',
                    },
                });
            } else {
                this.$router.push({
                    name: 'conta.vigentes',
                    query: {
                        contrato_id: this.form.contrato_id,
                        open_form: 1,
                        tab: 'financeiro',
                    },
                });
            }
        },
        onIaDadosExtraidos(dados) {
            const partesMensagem = ['Dados extraídos pela IA:'];

            if (dados.valor !== null && dados.valor !== undefined) {
                if (!this.form.valor) {
                    this.form.valor = dados.valor;
                    partesMensagem.push(`Valor R$ ${Number(dados.valor).toFixed(2).replace('.', ',')}`);
                }
            }

            if (dados.data_vencimento) {
                if (!this.form.data_vencimento) {
                    const partes = dados.data_vencimento.split('-');
                    if (partes.length === 3) {
                        this.form.data_vencimento = new Date(`${dados.data_vencimento}T12:00:00`);
                        partesMensagem.push(`Vencimento ${partes[2]}/${partes[1]}/${partes[0]}`);
                    }
                }
            }

            if (dados.codigo_de_barras) {
                this.form.codigo_de_barras = dados.codigo_de_barras;
            }

            if (partesMensagem.length > 1) {
                this.$toast.add({
                    severity: 'info',
                    summary: 'IA preencheu os campos',
                    detail: partesMensagem.join(' — '),
                    life: 8000,
                });
            }

            if (dados.avisos && dados.avisos.length > 0) {
                dados.avisos.forEach(aviso => {
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Aviso IA',
                        detail: aviso,
                        life: 10000,
                    });
                });
            }

            // Muda para aba Informações para o usuário revisar os dados preenchidos
            this.tabIndex = 0;
        },
        onUploadFile(event) {
            switch (event.route) {
                case 'comprovante':
                    this.form.comprovante_id = event.data.id;
                    this.form.comprovante = event.data.nome;
                    this.form.comprovante_date = event.data.created_at;
                    this.form.comprovante_usuario = event.data.usuario.nome;
                    break;

                default:
                    this.form.boleto_id = event.data.id;
                    this.form.boleto = event.data.nome;
                    this.form.boleto_date = event.data.created_at;
                    this.form.boleto_usuario = event.data.usuario.nome;
                    this.form.codigo_de_barras = event.data.conta.codigo_de_barras;
                    break;
            }
            this.$emit('save');
        },
        onRemoveFile(route) {
            switch (route) {
                case 'comprovante':
                    this.form.comprovante_id = null;
                    this.form.comprovante = null;
                    this.form.comprovante_date = null;
                    this.form.comprovante_usuario = null;
                    break;

                default:
                    this.form.boleto_id = null;
                    this.form.boleto = null;
                    this.form.boleto_date = null;
                    this.form.boleto_usuario = null;
                    this.form.codigo_de_barras = null;
                    break;
            }
            this.$emit('save');
        },
        selectContrato(contrato){
            this.contrato = contrato; // Guarda o contrato para referência
            this.form.id_primario   = contrato.id_primario;
            this.form.contrato_id   = contrato.id;
            this.form.justificativa_preco = null;
            delete this.errors.justificativa_preco;
            // Salva cliente do contrato para filtrar o seletor futuramente
            this.clienteId = contrato.cliente_id || null;
            this.clienteNome = contrato.cliente || null;
            // Atualiza o valor baseado no tipo selecionado
            this.atualizarValorPorTipo(this.form.tipo_conta);
            this.loadPagamentoRequisitos();
        },
        /**
         * Método público — usado por componentes-pai (ex: FrenteFinanceiroOperador)
         * via `$refs` quando resolvem pendências do contrato (financeiro/assinatura)
         * em sub-popups e querem que o ContaForm re-valide SEM perder o preenchimento.
         */
        revalidarRequisitos() {
            this.loadPagamentoRequisitos();
        },
        /**
         * Método público — sugere Valor e Vencimento vindos do contrato (mensalidade
         * configurada em contratos_contas). Só preenche se o campo estiver vazio —
         * não sobrescreve o que o operador já digitou.
         */
        sugerirValoresContrato({ valor, vencimento } = {}) {
            if (valor != null && !this.form.valor) {
                const num = Number(valor);
                if (!Number.isNaN(num)) {
                    this.form.valor = num;
                }
            }
            if (vencimento && !this.form.data_vencimento) {
                const data = this.normalizarParaDate(vencimento);
                if (data) {
                    this.form.data_vencimento = data;
                }
            }
        },
        /**
         * Converte robusticamente qualquer entrada (Date object, ISO completa, YYYY-MM-DD)
         * em um Date válido. Retorna null se não for parseável.
         */
        normalizarParaDate(valor) {
            if (valor === null || valor === undefined || valor === '') return null;
            if (valor instanceof Date) {
                return Number.isNaN(valor.getTime()) ? null : valor;
            }
            const s = String(valor).trim();
            if (!s) return null;
            // ISO completo (com timezone): "2026-06-12T00:00:00.000000Z"
            if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
                const d = new Date(s);
                return Number.isNaN(d.getTime()) ? null : d;
            }
            // Apenas data: "2026-06-12"
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const d = new Date(`${s}T12:00:00`);
                return Number.isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(s);
            return Number.isNaN(d.getTime()) ? null : d;
        },
        loadPagamentoRequisitos() {
            const params = {};
            if (this.form.contrato_id) {
                params.contrato_id = this.form.contrato_id;
            } else if (this.form.justificativa_preco) {
                params.justificativa_preco = this.form.justificativa_preco;
            }

            this.isLoadingPagamentoRequisitos = true;
            Conta.pagamentoRequisitos(params)
                .then((response) => {
                    this.pagamentoRequisitos = {
                        ok: response.data.ok !== false,
                        msg: response.data.msg || null,
                        erros: response.data.erros || {},
                    };
                    // Auto-emit de pendência removido a pedido — o usuário clica no link manualmente.
                })
                .catch((error) => {
                    const payload = error.response?.data || {};
                    this.pagamentoRequisitos = {
                        ok: false,
                        msg: payload.msg || 'Não foi possível validar os requisitos de pagamento.',
                        erros: payload.erros || {},
                    };
                    // Auto-emit de pendência removido a pedido — o usuário clica no link manualmente.
                })
                .finally(() => {
                    this.isLoadingPagamentoRequisitos = false;
                });
        },
        /**
         * Em modo embedded, quando a checagem de requisitos volta com pendência
         * (ok === false), o pai recebe um evento para abrir o popup de configuração
         * correto (assinatura vs financeiro). A flag `pendenciaJaEmitida` evita
         * disparo repetido pro mesmo estado de pendência.
         */
        emitirPendenciaSeNecessario() {
            if (this.mode !== 'embedded') return;
            if (!this.form.contrato_id) return;
            const temPendencia = this.pagamentoRequisitos.ok === false;
            if (!temPendencia) {
                this.pendenciaJaEmitida = false;
                return;
            }
            if (this.pendenciaJaEmitida) return;
            this.pendenciaJaEmitida = true;
            this.$emit('configurar-contrato', {
                tipo: this.pagamentoRequisitos.erros?.assinatura ? 'assinatura' : 'financeiro',
                contrato_id: this.form.contrato_id,
            });
        },

        atualizarValorPorTipo(tipo) {
            if (!this.contrato || !this.contrato.id) return;
            
            if (tipo === 'mensalidade') {
                // Para mensalidade, usa o valor com desconto ou valor original da cotação
                this.form.valor = this.contrato.cotacao_valor_desconto || this.contrato.cotacao_valor;
            } else if (tipo === 'prorata') {
                // Para prorata, pode usar o valor mensal proporcional (você pode ajustar a lógica)
                this.form.valor = this.contrato.cotacao_valor_desconto || this.contrato.cotacao_valor;
            }
            // Para 'avulso', não preenche automaticamente - o usuário define manualmente
        },

        clearContrato() {
            this.contrato = {};
            this.form.id_primario = null;
            this.form.contrato_id = null;
            this.clienteId = null;
            this.clienteNome = null;
            this.loadPagamentoRequisitos();
        },

        carregarTiposCobranca() {
            if (this.tiposCobrancaOpcoes.length > 0) return;
            Conta.tiposCobranca()
                .then(response => { this.tiposCobrancaOpcoes = response.data; })
                .catch(() => {});
        },

        carregarRegrasIntegridade() {
            Integridade.regras('conta')
                .then(response => {
                    this.regrasIntegridade = response.data?.data || {};
                })
                .catch(() => {
                    this.regrasIntegridade = {
                        justificativa_label: 'Justificativa de preços',
                        justificativa_min: 10,
                        justificativa_obrigatoria_sem_referencia: true,
                    };
                });
        },

        onShow() {
            // Liga flag anti-loop ANTES de mexer em `form` — bloqueia cascata de watchers.
            this.isInitializing = true;
            this.errors = {};
            this.clienteId = null;
            this.clienteNome = null;
            this.pendenciaJaEmitida = false;
            this.form = Conta.parse({ ...this.data });
            // Retrato tirado antes dos watchers/abas mexerem no form: é "o que foi carregado".
            this.formOriginal = retratoEditavel(this.form);
            this.justificativa = { visivel: false, texto: '', erro: '' };
            this.carregarRegrasIntegridade();
            this.carregarTiposCobranca();
            this.tabIndex = typeof this.initialTabIndex === 'number' && this.initialTabIndex > 0
                ? this.initialTabIndex
                : 0;
            // Popula cliente a partir do contrato já vinculado (edição)
            if (this.contrato && this.contrato.cliente_id) {
                this.clienteId = this.contrato.cliente_id;
                this.clienteNome = this.contrato.cliente || null;
            }
            // Dispara UMA única vez a checagem inicial — depois libera os watchers.
            // Em modo 'embedded', confiamos que o pai já validou; só carregamos uma vez.
            this.loadPagamentoRequisitos();
            // Libera os watchers após o tick — assim mudanças subsequentes do usuário continuam reagindo.
            this.$nextTick(() => {
                this.isInitializing = false;
            });
        },
        onHide() {
            this.tabIndex = 0;
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Conta.update(form.id, form);
            }
            return Conta.create(form);
        },
        /**
         * Pré-cadastro opcional do beneficiário no provedor do contrato (checkbox da aba Beneficiário).
         * Roda depois de salvar a conta: falha aqui não desfaz o salvamento, só avisa.
         */
        preCadastrarBeneficiario(form) {
            const nome = (form.beneficiario_nome || '').trim();
            const cnpj = (form.beneficiario_cnpj || '').replace(/\D/g, '');

            if (!form.beneficiario_pre_cadastrar || !form.contrato_id || !nome || cnpj.length !== 14) {
                return Promise.resolve();
            }

            return Provedor.beneficiarioSalvar({ contrato_id: form.contrato_id, cnpj, nome })
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Pronto', detail: 'Beneficiário cadastrado no provedor.', life: 3000 });
                })
                .catch(error => {
                    const msg = error.response?.data?.msg || 'Conta salva, mas o cadastro do beneficiário no provedor falhou.';
                    this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: msg, life: 7000 });
                });
        },
        pedirJustificativa(erro = '') {
            this.justificativa.erro = erro;
            this.justificativa.visivel = true;
        },
        onConfirmarJustificativa(texto) {
            this.justificativa.visivel = false;
            this.justificativa.erro = '';
            this.onSubmit(this.form, texto);
        },
        /**
         * @param justificativaAlteracao só vem preenchida pelo diálogo de justificativa.
         *   Não fica guardada entre tentativas: cada envio de edição com mudança passa
         *   pelo diálogo (que reabre já com o texto anterior).
         */
        onSubmit(form, justificativaAlteracao = null) {
            this.errors = {};

            if (!this.podeSalvarPagamento) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Pagamento bloqueado',
                    detail: this.pagamentoRequisitos.msg || 'Atenda os requisitos antes de salvar.',
                    life: 8000,
                });
                return;
            }

            // Validação Frontend: Impede salvar sem escolher o tipo
            if (!form.tipo_conta) {
                this.errors['tipo_conta'] = 'Selecione o tipo da conta.';
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Selecione se é Mensalidade, Prorata ou Avulso.', life: 3000 });
                return;
            }

            if (!form.tipo_cobranca) {
                this.errors['tipo_cobranca'] = 'Selecione o tipo de cobrança.';
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Selecione o Tipo de Cobrança.', life: 3000 });
                return;
            }

            const minJustificativa = this.regrasIntegridade.justificativa_min || 10;
            if (!form.contrato_id) {
                const justificativa = (form.justificativa_preco || '').trim();
                if (!justificativa) {
                    this.errors.justificativa_preco = 'Informe a justificativa de preços.';
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Sem contrato vinculado, a justificativa é obrigatória.', life: 4000 });
                    return;
                }
                if (justificativa.length < minJustificativa) {
                    this.errors.justificativa_preco = `A justificativa deve ter no mínimo ${minJustificativa} caracteres.`;
                    return;
                }
            }

            // Edição com mudança visível: pede o motivo antes de enviar. Sem mudança, salva
            // direto — se o servidor discordar, o 422 abaixo abre o mesmo diálogo.
            if (form.id && !justificativaAlteracao && formularioMudou(this.formOriginal, form)) {
                this.pedirJustificativa();
                return;
            }

            this.isLoading = true;

            // Tradução tipo_conta para mensalidade/prorata
            let dadosParaEnviar = { ...form };
            if (form.id && justificativaAlteracao) {
                dadosParaEnviar[CAMPO_JUSTIFICATIVA] = justificativaAlteracao;
            }
            // Flag só de UI (aba Beneficiário) — não faz parte do payload da conta.
            delete dadosParaEnviar.beneficiario_pre_cadastrar;
            if (form.tipo_conta === 'mensalidade') {
                dadosParaEnviar.mensalidade = 1;
                dadosParaEnviar.prorata = 0;
            } else if (form.tipo_conta === 'prorata') {
                dadosParaEnviar.mensalidade = 0;
                dadosParaEnviar.prorata = 1;
            } else {
                // Avulso
                dadosParaEnviar.mensalidade = 0;
                dadosParaEnviar.prorata = 0;
            }

            this.save(dadosParaEnviar)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    return this.preCadastrarBeneficiario(form).then(() => {
                        this.form = Conta.parse(response.data.data);
                        // No modo embedded o form segue aberto: o salvo vira a nova base.
                        this.formOriginal = retratoEditavel(this.form);
                        this.justificativa.texto = '';
                        this.$emit('save', response.data.data);
                        this.$emit('close');
                    });
                })
                .catch(error => {
                    // O servidor tem a palavra final sobre "mudou": se ele pediu a justificativa,
                    // abre o diálogo em vez de erro genérico. A mensagem dele só aparece se já
                    // tínhamos mandado uma (ex.: curta demais) — senão o próprio diálogo explica.
                    const erroJustificativa = form.id ? erroDeJustificativa(error) : null;
                    if (erroJustificativa) {
                        this.pedirJustificativa(justificativaAlteracao ? erroJustificativa : '');
                        return;
                    }
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            let primeiraMensagem = null;
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                                if (!primeiraMensagem) {
                                    primeiraMensagem = Array.isArray(err.erros[i])
                                        ? err.erros[i][0]
                                        : err.erros[i];
                                }
                            }
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Não foi possível salvar',
                                detail: primeiraMensagem || 'Revise os campos obrigatórios e tente novamente.',
                                life: 7000
                            });
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>
